<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>

<page-content>
  <mat-card appearance="outlined">
    <smart-input [(model)]="banner" hintTranslationPrefix="banner.hints" key="link" translationPrefix="banner"></smart-input>
  </mat-card>

  <mat-card appearance="outlined" class="images-container">
    <h2>Bannerbild</h2>
    <div class="main-actions">
      <button (click)="chooseFromImageAssets()" class="ibexfusion-raised-button small" mat-button>{{ 'dynamicContent.chooseImage' | translate }}</button>
    </div>
    <div class="table-header">
      <div class="preview"></div>
      <div class="title">{{'general.title' | translate}}</div>
      <div class="date">{{ 'general.created' | translate }}</div>
      <div class="size">{{'general.size' | translate}}</div>
      <div class="actions"></div>
    </div>

    <div class="table">
      <div class="table-row" *ngIf="!!imageUrl">
        <div class="preview">
          <img  [src]="imageUrl" />
        </div>
        <div class="title">{{ image?.title }}</div>
        <div class="date">
          <ng-container *ngIf="image?.created">{{ image.created | date:'dd.MM.YYYY' }}</ng-container>
        </div>
        <div class="size">
          <ng-container *ngIf="image?.fileSize">{{ image.fileSize | fileSize }}</ng-container>
        </div>
        <div class="actions">
          <button class="ibexfusion-icon-button" mat-icon-button (click)="chooseFromImageAssets()"><mat-icon>edit</mat-icon></button>
          <button class="ibexfusion-icon-button" mat-icon-button (click)="cleanImage()"><mat-icon>delete</mat-icon></button>
        </div>
      </div>
    </div>
  </mat-card>

  <div class="button-right-container">
    <button (click)="onSave()" class="ibexfusion-raised-button" mat-button>{{ 'general.save' | translate }}</button>
  </div>
</page-content>
